<template>
	<div class="homes">
		<!-- <bgcanvas></bgcanvas> -->
		<div class="header">
			<div class="content">
				<img src="../../../static/img/logo12.png" height="56" width="590" alt="" class="header-logo">
			</div>
		</div>
		<div class="content-box">
			<!--<div class="content-header" style="color:#999">选择申报单位</div>-->
			<!--<ul class="content-con">
				<li v-for="(item,index) in detail" @click="liclick(item)" :key="index">
					<a>{{item.value}}</a>
				</li>
			</ul>-->
			<!--<p @click="add_path" class="content-p" style="font-size: 20px;">新建申报单位</p>-->
			<el-button type="primary" @click="add_path" class="" style="font-size: 16px;width: 160px; margin-left: 100px ;">新建申报单位</el-button>
		</div>
	</div>
</template>
<script>
	import bgcanvas from '../component/Bgcanvas'
	import company from '../../data/basic/plan/company.js'
	import { mapMutations, mapState } from 'vuex'
	export default {
		data() {
			return {
				detail: [],
			}
		},
		created() {
			 // this.getData()
		},
		methods: {
			...mapMutations(['getNameList', 'changeIsRendering', 'showlist']),
			// 获取机构
			getData() {
				(async() => {
					let getState = await company.get_searchlist()
					if(getState.status) {
						let datalist = getState.data
						let namalist = []

						if(datalist.length >= 1) {
							for(let i = 0; i < datalist.length; i++) {
								namalist.push({
									value: datalist[i].name,
									id: datalist[i].id,
									type: datalist[i].type
								})
							}

							sessionStorage.itemName = JSON.stringify(namalist[0])
							this.changeIsRendering(namalist[0].type)

							sessionStorage.itemNamea = JSON.stringify(namalist)
							this.getNameList(JSON.stringify(namalist))
							this.$router.push('/')
						} else {
							this.$router.push('Home')
						}
					} else {
						this.$message.error(getState.msg)
					}
				})()
			},
			liclick(item) {
				sessionStorage.itemName = JSON.stringify(item)
				this.changeIsRendering(item.type)
				this.$router.push('/')
			},
			// 修改密码
			modpwd() {
				this.$router.push('/modpwd')
			},
			// 个人资料
			userdetails() {
				this.$router.push('/user')
			},
			add_path() {
				this.$router.push('/myunit')
				this.showlist(true)
				sessionStorage.itemName = 0
			}
		},
		components: {
			bgcanvas
		}
	}
</script>
<style lang="stylus" scoped>
	.homes {
		width: 100%;
		height: 100%;
		position relative;
		overflow: hidden;
	}
	
	.header {
		position: relative;
		width: 100%;
		height: 90px;
		box-sizing: border-box;
		box-shadow: 2px 2px 20px #dddddd;
		background: url('../../../static/img/headerpublic.png') 100% 100% no-repeat;
		.content {
			width: 1200px;
			height: 90px;
			margin: 0 auto;
			.header-logo {
				display: inline-block;
				margin-top: 17px;
				float: left;
				cursor: pointer;
			}
		}
	}
	
	.content-box {
		margin: 0 auto;
		position: relative;
		width: 400px;
		min-height: 300px;
		height: auto;
		box-sizing: border-box;
		border-radius: 5px; // border: 1px solid #DCDCDC;
		// box-shadow : 0 0 2px rgba(0, 0, 0, .2);
		transition: all .5s ease-in-out;
		transform: scale(1.2);
		margin: 120px auto 0; 
		// background : #fff;
		.content-header {
			height: 40px;
			width: 100%;
			text-align: center;
			line-height: 40px;
			font-size: 14px; // border-bottom: 1px solid #DCDCDC;
			// background: url('../../../static/img/title.jpg') 100% 100% no-repeat;
			background-size: 100% 100%;
			transition: all .3s ease-in-out; // color:#20a0ff;
		} // &:hover .content-header {
		// 	border-bottom: 1px solid transparent;
		// }
		// &:hover {
		// 	transform: scale(1.2);
		// 	background: #fff;
		// 	box-shadow: 0 0 10px rgba(0, 0, 0, .2);
		// }
		.content-con {
			width: 100%;
			position: relative;
			height: auto;
			li {
				width: 100%;
				height: 40px;
				text-align: center;
				line-height: 40px;
				font-size: 16px;
				border: 1px solid transparent;
				cursor: pointer;
				list-style-type: none;
				a {
					width: 90%;
					height: 90%;
					display: inline-block;
					transition: all .2s;
					transform: scale(.9);
					background: transparent;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					&:hover {
						border-radius: 5px;
						width: 100%;
						height: 100%;
						transform: scale(1);
						background: #fff; // opacity: .6;
						color: #000; // transform: scale(1.2);
					}
				} // &:last-child {
				//   font-size: 14px;
				// }
			} // &:hover {
			// 	 border: 1px solid #EFEFEF;
			// }
		} // .content-con li:hover {
		//   // border: 1px solid #EFEFEF;
		//   border: 1px solid #EFEFEF; // transform: scale(1.2);
		//   border-radius:20px;
		// } // &:hover .content-con li {
		// 	// border: 1px solid #EFEFEF;
		// }
	}
	
	.content-p {
		color: #20a0ff;
		font-size: 12px;
		text-align: center;
		cursor: pointer;
		margin-top: 10px;
	}
</style>


// WEBPACK FOOTER //
// Home.vue?7d53ff48